var _style, _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBancaSistemaReduxWhiteNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 537 74",
    width: 144,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #222222 }\n\t\t.s1 { fill: #ffffff }\n\t\t.s2 { fill: #b91f27 }\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m-32-203h595.3v476.9l-595.3 0.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m-0.1 23.9h16.4c12.5 0 19.7 4.3 19.7 12.7 0 4.3-2.6 7.9-7.5 10.3 6.4 3.3 8.9 6 8.9 12.1 0 9.8-8.1 14.2-20.4 14.2h-17.1zm11.7 19.6h4.1c5.2 0 8.6-2.5 8.6-5.8 0-3.7-2.6-6-8.1-6h-4.6zm0 22h4.9c6.1 0 9.3-2.9 9.3-7.2 0-4.7-4.1-7-10.2-7h-4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m69.8 23.9l14.7 49.4h-11.1l-3-10.4h-16.1l-3.3 10.4h-11.2l15.1-49.4zm-13.4 30.6h11.5l-5.6-19.9h-0.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m118 24v29.2h-0.1l-16.2-29.2h-12.8v49.3h10.7v-31.8h0.1l17.8 31.8h11.2v-49.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m148 58.4c0 5.4 3 6.8 7.6 6.8 4.6 0 7.6-1.4 7.6-6.8v-3.2h11.7v2c0 11.9-8 16.1-19.3 16.1-11.3 0-19.2-4.2-19.2-16.1v-17.1c0-11.8 7.9-16.1 19.2-16.1 11.3 0 19.3 4.3 19.3 16.1v0.1h-11.7v-1.3c0-5.3-2.9-6.8-7.6-6.8-4.6 0-7.6 1.5-7.6 6.8 0 0 0 19.5 0 19.5z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m206.4 24l14.7 49.3h-11.2l-2.9-10.4h-16.2l-3.2 10.4h-11.3l15.1-49.3zm-13.4 30.6h11.6l-5.7-19.9h-0.1z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m268.3 38.1c-2-4.5-4.5-6.5-8.6-6.5-4.2 0-6.5 2-6.5 5.3 0 7.3 26.3 7.8 26.3 22.9 0 8.2-7.3 13.7-19.7 13.7-9.6 0-17-4.1-20.2-13.5l11.7-2c1.3 5.8 5.6 7.9 9.1 7.9 4.1 0 7.3-2.1 7.3-5.7 0-9.1-26.3-9.2-26.3-22.7 0-8.3 6.3-13.5 18.5-13.5 10.5 0 16.9 4.9 19 11.7z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m286.1 23.9h11.8v49.7h-11.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m333.1 38.1c-2-4.5-4.6-6.5-8.7-6.5-4.1 0-6.5 2-6.5 5.3 0 7.3 26.4 7.8 26.4 22.9 0 8.2-7.3 13.7-19.7 13.7-9.6 0-17-4.1-20.2-13.5l11.7-2c1.3 5.8 5.6 7.9 9.1 7.9 4.1 0 7.3-2.1 7.3-5.7 0-9.1-26.4-9.2-26.4-22.7 0-8.3 6.4-13.5 18.6-13.5 10.5 0 16.9 4.9 19 11.7z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m347.7 23.9v8.4h13.8v41.3h11.8v-41.3h13.7v-8.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m393.2 23.9v49.7h33.2v-8.4h-21.4v-13.1h15.6v-8.4h-15.6v-11.4h20.5v-8.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m470.3 23.9l-10.7 32.6h-0.1l-10.7-32.6h-16.5v49.7h10.1v-39.1h0.1l12.6 39.1h8.9l12.5-39.1h0.2v39.1h10.1v-49.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m521.7 23.9l14.8 49.7h-11.2l-3-10.5h-16.4l-3.3 10.5h-11.4l15.3-49.7zm-13.5 30.8h11.7l-5.8-20h-0.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m285.8 0.1h12.1v12.1h-12.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m309.6 0.1h177.2v12.1h-177.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancaSistemaReduxWhiteNew);
export default __webpack_public_path__ + "static/media/banca_sistema_redux_white_new.c6d6455b31c662e4219365018af4b5d6.svg";
export { ForwardRef as ReactComponent };